import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useAccount } from '../contexts/Account';
import { useLocation } from 'react-router-dom';
import { AccountType } from '../services/utils/types';
import {
  getAdvisorQueryParams,
  getCompanyQueryParams,
} from '../utils/queryParams';

function DynamicIFrameScene() {
  const { accountDetails, isFreeTrial, isFreemium, currentPlan, type } =
    useAccount();
  const [url, setUrl] = useState(null);
  const mobileTopAvisor = isFreeTrial
    ? '126px'
    : currentPlan.specialOffersUrl
    ? '124px'
    : '66px';
  const desktopTopAdvisor = isFreeTrial
    ? '126px'
    : currentPlan.specialOffersUrl
    ? '100px'
    : '66px';

  const location = useLocation();

  useEffect(() => {
    const ubRoute = location.pathname.startsWith('/ub');
    const startingUrl = ubRoute
      ? 'https://register.advisorycloud.com'
      : 'https://advisorycloud.com';

    const customRoute = location.pathname.replace(ubRoute ? '/ub' : '/wf', '');
    let queryParamsByType = '';
    if (type === AccountType.ADVISOR) {
      queryParamsByType = getAdvisorQueryParams({
        accountDetails,
        isFreeTrial,
        isFreemium,
      });
    } else {
      queryParamsByType = getCompanyQueryParams({ accountDetails });
    }

    console.log(startingUrl + customRoute + '?' + queryParamsByType);
    setUrl(startingUrl + customRoute + '?' + queryParamsByType);
  }, [location.search]);

  return (
    <Box
      sx={{
        position: 'fixed',
        top:
          type === AccountType.ADVISOR
            ? { xxs: mobileTopAvisor, sm: desktopTopAdvisor }
            : { xxs: '110px', sm: '58px' },
        left: 0,
        right: 0,
        bottom: 0,
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
        touchAction: 'pan-y',
        overscrollBehavior: 'contain',
      }}
    >
      <iframe
        src={url}
        style={{
          border: 'none',
          width: '100%',
          height: '100%',
          display: 'block',
          touchAction: 'pan-y',
          WebkitOverflowScrolling: 'touch',
        }}
      />
    </Box>
  );
}

export default DynamicIFrameScene;
